import clsx from 'clsx';

export type ChipVariant = 'primary' | 'outline' | 'light';

export interface ChipProps {
  onClick?(): void;
  label: string;
  variant?: ChipVariant;
  size?: 'sm' | 'md' | 'lg';
  Icon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element; //svg
  title?: string;
  iconPlacement?: 'left' | 'right';
}

function resolveVariantClasses(variant: ChipVariant) {
  switch (variant) {
    case 'light':
      return clsx('bg-neutral-40', 'text-neutral-80');

    case 'outline':
      return clsx('ring-secondary-60', 'text-neutral-80', 'ring-2');
  }

  return clsx('bg-neutral-80', 'text-neutral-0');
}

export function Chip({
  variant = 'primary',
  label,
  onClick,
  size = 'md',
  Icon,
  title,
  iconPlacement = 'left',
}: ChipProps) {
  const Component = onClick ? 'button' : 'div';
  return (
    <Component
      onClick={onClick}
      title={title}
      className={clsx(
        'inline-flex items-center whitespace-nowrap',
        'rounded-full px-3',
        'group',
        resolveVariantClasses(variant),
        size === 'sm' && 'text-xs',
        size === 'md' && 'text-sm leading-loose px-4 py-1',
        size === 'lg' && 'text-base leading-loose px-6 py-2'
      )}
    >
      {Icon && iconPlacement == 'left' && (
        <Icon className="h-3 w-4 mr-2 " aria-hidden="true" />
      )}

      {label}

      {onClick && (
        <span
          className={clsx(
            'inline-flex items-center justify-center',
            'flex-shrink-0',
            'h-4 w-4',
            'rounded-full',
            size === 'lg' ? 'ml-2' : 'ml-1',
            variant === 'light' && 'bg-neutral-80 text-neutral-0',
            'focus:outline-none',
            'group-hover:bg-text-danger group-hover:text-neutral-0'
          )}
        >
          <svg
            className="h-2 w-2"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
          >
            <path
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M1 1l6 6m0-6L1 7"
            />
          </svg>
        </span>
      )}
      {Icon && iconPlacement == 'right' && (
        <Icon className="h-3 w-4 ml-2 " aria-hidden="true" />
      )}
    </Component>
  );
}

export default Chip;
